import type { AssignmentDetail } from '@parinaam-vms/shared';
import { apiDelete, apiGet, apiPost } from './client';

export interface CreateAssignmentBody {
  volunteer_id: string;
  session_id: string;
  notes?: string | null;
  /**
   * Plan D4. Sent only on the retry, after the API has answered
   * `OVERLAP_DETECTED` and staff have seen what the clash is. Never on a first
   * attempt — the point of the flow is that the warning is read.
   */
  allow_overlap?: boolean;
}

export function fetchActivityAssignments(activityId: string): Promise<AssignmentDetail[]> {
  return apiGet<AssignmentDetail[]>(`/activities/${activityId}/assignments`);
}

export function createAssignment(body: CreateAssignmentBody): Promise<AssignmentDetail> {
  return apiPost<AssignmentDetail>('/assignments', body);
}

/**
 * Cancels the assignment; it does not remove it (§4.22).
 *
 * `DELETE` is the verb in the API contract and matches the intent, but the
 * response is the cancelled record rather than an empty 204 — the row still
 * exists and the roster needs its new state.
 */
export function cancelAssignment(id: string): Promise<AssignmentDetail> {
  return apiDelete<AssignmentDetail>(`/assignments/${id}`);
}
